import { render, staticRenderFns } from "./CharCount.vue?vue&type=template&id=6d2d9324&scoped=true&"
import script from "./CharCount.vue?vue&type=script&lang=js&"
export * from "./CharCount.vue?vue&type=script&lang=js&"
import style0 from "./CharCount.vue?vue&type=style&index=0&id=6d2d9324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2d9324",
  null
  
)

export default component.exports